import { render, staticRenderFns } from "./HistoricoCadastral.vue?vue&type=template&id=04670268"
import script from "./HistoricoCadastral.vue?vue&type=script&lang=js"
export * from "./HistoricoCadastral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports